export const TEMPLATE_LIST_ACTION_USE = 'TEMPLATE_LIST_ACTION_USE';
export const TEMPLATE_LIST_ACTION_EDIT = 'TEMPLATE_LIST_ACTION_EDIT';
export const TEMPLATE_LIST_ACTION_DUPLICATE = 'TEMPLATE_LIST_ACTION_DUPLICATE';
export const TEMPLATE_LIST_ACTION_OPEN_DELETE_MODAL =
  'TEMPLATE_LIST_ACTION_OPEN_DELETE_MODAL';

export const POST_CREATE_TEMPLATE_REQUEST = 'POST_CREATE_TEMPLATE_REQUEST';
export const POST_CREATE_TEMPLATE_SUCCESS = 'POST_CREATE_TEMPLATE_SUCCESS';
export const POST_CREATE_TEMPLATE_FAILURE = 'POST_CREATE_TEMPLATE_FAILURE';

export const POST_DUPLICATE_TEMPLATE_REQUEST =
  'POST_DUPLICATE_TEMPLATE_REQUEST';
export const POST_DUPLICATE_TEMPLATE_SUCCESS =
  'POST_DUPLICATE_TEMPLATE_SUCCESS';
export const POST_DUPLICATE_TEMPLATE_FAILURE =
  'POST_DUPLICATE_TEMPLATE_FAILURE';

export const TEMPLATE_LIST_ACTION_DELETE = 'TEMPLATE_LIST_ACTION_DELETE';
export const DELETE_TEMPLATE_REQUEST = 'DELETE_TEMPLATE_REQUEST';
export const DELETE_TEMPLATE_SUCCESS = 'DELETE_TEMPLATE_SUCCESS';
export const DELETE_TEMPLATE_FAILURE = 'DELETE_TEMPLATE_FAILURE';

export const NAVIGATE_TO_TEMPLATE_EDITOR = 'NAVIGATE_TO_TEMPLATE_EDITOR';
export const NAVIGATE_TO_SURVEY_EDITOR = 'NAVIGATE_TO_SURVEY_EDITOR';
export const NAVIGATE_TO_TEMPLATE_QUICK_VIEW =
  'NAVIGATE_TO_TEMPLATE_QUICK_VIEW';
export const LOAD_TEMPLATE_LIST = 'LOAD_TEMPLATE_LIST';
export const MOUNT_TEMPLATE_LIST = 'MOUNT_TEMPLATE_LIST';
export const TOGGLE_TEMPLATE_TILE_FAVORITE = 'TOGGLE_TEMPLATE_TILE_FAVORITE';
export const TEMPLATE_TAB_CHANGE = 'TEMPLATE_TAB_CHANGE';
export const LOAD_TEMPLATE_LIST_PREVIEW_OPTIONS =
  'LOAD_TEMPLATE_LIST_PREVIEW_OPTIONS';
export const ON_TEMPLATE_SEARCH = 'ON_TEMPLATE_SEARCH';
export const USE_TEMPLATE = 'USE_TEMPLATE';
export const SORT_TEMPLATE_LIST_COLUMN = 'SORT_TEMPLATE_LIST_COLUMN';
